import { Bell } from 'lucide-react'
import { Link } from 'react-router-dom'

import { useAlertSummary } from '../api/control'

/** El contador de alertas sin ver, en la barra superior.
 *
 *  Muestra la severidad y no sólo el número: doce avisos y doce bots pausados
 *  por drawdown son doce cosas distintas, y un contador a secas los dice
 *  igual.
 */
export function AlertsBell() {
  const { data: summary } = useAlertSummary()
  const pending = summary?.pending ?? 0
  const tone = !summary || !pending ? '' : summary.critical ? ' is-critical' : ' is-warning'

  return (
    <Link
      to="/alertas"
      className={`alerts-bell${tone}`}
      title={pending ? `${pending} alertas sin ver` : 'Sin alertas pendientes'}
      aria-label={pending ? `${pending} alertas sin ver` : 'Alertas'}
    >
      <Bell size={16} aria-hidden="true" />
      {pending > 0 && <span className="alerts-bell__count">{pending > 99 ? '99+' : pending}</span>}
    </Link>
  )
}
